<template>
<div>
      <v-autocomplete
        v-model="value"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        color="primary"
        hide-selected
        item-text="full_text"
        item-value="id"
        :label="label || 'Buscar Cliente'"
        placeholder="Ingrese nombre, RUT o fantasía..."
        return-object
        outlined
        clearable
        @input="updateValue"
        @change="cambio"
        dense
        :disabled="disabled"
        hide-details="auto"
        class="custom-autocomplete"
      >
        <template v-slot:selection="{ item }">
          <div class="d-flex align-center">
            <v-icon x-small class="mr-2" color="primary">fas fa-user</v-icon>
            <span class="body-2 font-weight-medium">{{item.name}}</span>
          </div>
        </template>
        
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title class="body-2 font-weight-bold">
              {{ item.name }}
            </v-list-item-title>
            <v-list-item-subtitle class="caption grey--text d-flex align-center">
              <v-icon x-small class="mr-1">fas fa-id-card</v-icon> {{ item.rut }}
              <v-icon v-if="item.fantasy" x-small class="ml-3 mr-1">fas fa-tag</v-icon> {{ item.fantasy }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>

        <template v-slot:no-data>
          <v-list-item v-if="allowCreate" @mousedown.prevent="openCreate">
            <v-list-item-content>
              <v-list-item-title class="primary--text font-weight-bold">
                Crear cliente para cotizar
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                No se encontró. Ingresa RUT, razón social y giro.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-else>
            <v-list-item-content>
              <v-list-item-title class="caption italic grey--text">
                No se encontraron clientes. Escriba para buscar...
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:append-item>
          <div v-if="allowCreate" class="px-3 py-2">
            <v-btn text small color="primary" class="px-0" @mousedown.prevent="openCreate">
              <v-icon left x-small>fas fa-plus</v-icon>
              Crear cliente
            </v-btn>
          </div>
        </template>
      </v-autocomplete>
      <div v-if="allowCreate && !value" class="mt-1">
        <v-btn text x-small color="primary" class="px-0" @click="openCreate">
          <v-icon left x-small>fas fa-plus</v-icon>
          Crear cliente nuevo
        </v-btn>
      </div>
      <quick-customer-dialog v-if="allowCreate" v-model="createDialog" :prefill="createPrefill" @created="onCreated" />
    </div>  
</template>

<script>
import {fetchCustomers, getCustomer} from '@/api/customers'
import QuickCustomerDialog from '@/components/customers/QuickCustomerDialog'

  export default {
    name:'CustomerComplete2',
    components: { QuickCustomerDialog },
    data: () => ({
      descriptionLimit: 60,
      customers: [],
      isLoading: false,
      model: null,
      search:null,
      items: [],
      timer:'',
      createDialog: false,
      createPrefill: {},
    }),
    props: {
      value: { required: false },
      status: { required: false },
      customer_name: { required: false },
      prependIcon: { required: false },
      dense: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      allowCreate: { type: Boolean, default: false },
      label: { type: String, default: 'Buscar Cliente' },
    },
    methods:{
      updateValue(){
        this.value ? this.$emit('input',this.value) : this.$emit('input','')
      },
      cleared(){
        this.$emit('input','')
      },
      cambio(){
        this.$emit('change')
      },
      openCreate() {
        this.createPrefill = { search: this.search || '', name: this.search || '' }
        this.createDialog = true
      },
      async onCreated(customer, contact) {
        if (!customer) return
        let fullCustomer = customer
        if (!fullCustomer.contacts || !fullCustomer.contacts.length) {
          try {
            fullCustomer = await getCustomer(customer.id)
          } catch (e) {
            fullCustomer = customer
          }
        }
        const row = { ...fullCustomer, full_text: `${fullCustomer.rut || ''} ${fullCustomer.name || ''}` }
        const exists = this.items.find((item) => item.id === fullCustomer.id)
        this.items = exists ? this.items.map((item) => (item.id === fullCustomer.id ? row : item)) : [row].concat(this.items)
        this.search = null
        const targetContact = contact || (fullCustomer.contacts && fullCustomer.contacts[0]) || null
        this.$emit('input', fullCustomer)
        this.$emit('change', fullCustomer)
        this.$emit('created', fullCustomer, targetContact)
      },
      querySelections (v) {
        this.isLoading = true
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(async () => {
          //sort = '', page = '', page_size = '', search = '', seller = '', status = ''
          await fetchCustomers('',1,-1,v,'',this.status)
          .then((res)=>{
            this.items=res.results.map(item=>{
              return {
                ...item,full_text:`${item.rut} ${item.name}`
              }
            })
          })

          this.isLoading=false
          },800)
        
        
      },
      searchTimeOut() {  
        //Función para hacer búsqueda lazy
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            this.fetch()
        }, 800);
      },
    },
    watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      },
      customer_name(val){
        if(val) this.search=val
      },
      value: {
        immediate: true,
        handler(val) {
          if (val && val.id) {
            const exists = this.items.some((item) => item.id === val.id)
            if (!exists) {
              const row = { ...val, full_text: `${val.rut || ''} ${val.name || ''}` }
              this.items = [row].concat(this.items)
            }
          }
        },
      },
    },
    
    
  }
</script>